import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { TESTIMONIALS } from "@/data/site";
import { ChevronLeft, ChevronRight, Quote } from "lucide-react";

export default function Testimonials() {
  const [i, setI] = useState(0);
  const t = TESTIMONIALS[i];
  const next = () => setI((i + 1) % TESTIMONIALS.length);
  const prev = () => setI((i - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);

  return (
    <section id="testimonials" className="relative py-32 md:py-48" data-testid="testimonials">
      <div className="container-mit">
        <div className="flex items-baseline justify-between mb-14">
          <p className="text-[11px] tracking-[0.4em] text-[#A4801C]">— VOICES</p>
          <p className="text-[11px] tracking-[0.3em] text-[#0A0A14]/50">
            {String(i + 1).padStart(2, "0")} / {String(TESTIMONIALS.length).padStart(2, "0")}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-start">
          <div className="md:col-span-2">
            <Quote className="text-[#A4801C]" size={72} strokeWidth={1} />
          </div>
          <div className="md:col-span-10">
            <AnimatePresence mode="wait">
              <motion.blockquote
                key={t.author}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.7 }}
                className="font-display font-light text-3xl md:text-5xl leading-[1.15] text-[#0A0A14] max-w-5xl"
                data-testid="testimonial-quote"
              >
                "{t.quote}"
              </motion.blockquote>
            </AnimatePresence>
            <div className="mt-10 flex items-center justify-between">
              <div>
                <div className="text-[#0A0A14] text-lg" data-testid="testimonial-author">{t.author}</div>
                <div className="text-[#0A0A14]/55 text-sm mt-1">{t.role}</div>
              </div>
              <div className="flex items-center gap-3">
                <button
                  onClick={prev}
                  data-testid="testimonial-prev"
                  className="w-11 h-11 rounded-full border border-[#0A0A14]/25 flex items-center justify-center text-[#0A0A14]/80 hover:border-[#1E1B4B] hover:text-[#4B1EAD] transition-colors"
                >
                  <ChevronLeft size={18} />
                </button>
                <button
                  onClick={next}
                  data-testid="testimonial-next"
                  className="w-11 h-11 rounded-full border border-[#0A0A14]/25 flex items-center justify-center text-[#0A0A14]/80 hover:border-[#1E1B4B] hover:text-[#4B1EAD] transition-colors"
                >
                  <ChevronRight size={18} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
